var React = require('react');

function PodcastRss (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M25.5987 32C25.5987 17.956 14.044 6.4 0 6.4V0C17.5533 0 32 14.4467 32 32H25.5987ZM4.388 23.22C6.80667 23.22 8.77867 25.192 8.77867 27.6133C8.77867 30.0307 6.79867 32 4.37733 32C1.96 32 0 30.0347 0 27.6133C0 25.192 1.96667 23.2213 4.388 23.22ZM21.212 32H14.992C14.992 23.7747 8.22533 17.0067 0 17.0067V10.7867C11.636 10.7867 21.212 20.3653 21.212 32Z","fill":"#303030"}));
}

PodcastRss.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = PodcastRss;

PodcastRss.default = PodcastRss;
